/**
 * Buscador de registros del panel de Leads (`GET /searchleadrecords`):
 * helpers puros. Contrato: argenlotapi/docs/frontend/FRONTEND_LEADS.md
 * § Buscar registros. Map: docs/maps/leads.md § Buscar registros.
 *
 * Copy (`.cursor/rules/ui-copy-lista-lote.mdc`): `cadastral_lot` /
 * `cad_parcel` → **Lote**, `user_lot` → **Unidad**. Lote y UF van separados:
 * el filtro es del registro elegido, nunca “lote + sus UFs”.
 */

const KIND_LABELS = { cadastral_lot: 'Lote', cad_parcel: 'Lote', user_lot: 'Unidad' };

/** “Lote” / “Unidad” según `item_kind`. Desconocido → ''. */
export function getLeadRecordKindLabel(itemKind) {
  return KIND_LABELS[String(itemKind || '').trim()] || '';
}

/**
 * Registro elegido (filtro del panel): `{ itemKind, id, label }`. Sin kind o
 * id → null.
 */
export function normalizeLeadRecordFilter(hit) {
  const itemKind = String(hit?.itemKind || '').trim();
  const id = String(hit?.id || '').trim();
  if (!KIND_LABELS[itemKind] || !id) return null;
  return { itemKind, id, label: String(hit?.label || '').trim() };
}

/** Query de `getLeads` para el registro: `{ itemKind, recordId }`. */
export function buildLeadRecordQuery(filter) {
  if (!filter?.id || !filter?.itemKind) return {};
  return { itemKind: filter.itemKind, recordId: filter.id };
}

/** Chip / resumen: “Unidad: Depto 14E” · “Lote: Esquina Salguero”. */
export function describeLeadRecordFilter(filter) {
  if (!filter?.id) return '';
  const kind = getLeadRecordKindLabel(filter.itemKind);
  return filter.label ? `${kind}: ${filter.label}` : kind;
}

/** Meta corta de un resultado: “3 consultas · 1 sin ver”. Sin nada → ''. */
export function describeLeadRecordCounts(counts) {
  const inquiries = Number(counts?.inquiryCount) || 0;
  const unseen = Number(counts?.unseenCount) || 0;
  if (!inquiries) return '';
  const base = `${inquiries} ${inquiries === 1 ? 'consulta' : 'consultas'}`;
  return unseen ? `${base} · ${unseen} sin ver` : base;
}

/**
 * Listas donde está un resultado del buscador (`include=lists`): “En Barrio
 * Norte, Torre 2 +1”. Sin listas → ''.
 *
 * @param {{ name: string }[]} lists
 * @param {number} [max] Nombres visibles antes del “+N”.
 * @returns {string}
 */
export function describeLeadRecordLists(lists, max = 2) {
  const names = (Array.isArray(lists) ? lists : []).map((l) => String(l?.name || '').trim()).filter(Boolean);
  if (!names.length) return '';
  const shown = names.slice(0, max).join(', ');
  return names.length > max ? `En ${shown} +${names.length - max}` : `En ${shown}`;
}
